import { render, staticRenderFns } from "./BlockEditorHeading2.vue?vue&type=template&id=40dd8c90&"
import script from "./BlockEditorHeading2.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorHeading2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports